import { render, staticRenderFns } from "./DashboardTagSelector.vue?vue&type=template&id=748f1cea"
import script from "./DashboardTagSelector.vue?vue&type=script&lang=js"
export * from "./DashboardTagSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports